import { FETCH_KEY_TECHNOLOGY_FAILURE, FETCH_KEY_TECHNOLOGY_REQUEST, FETCH_KEY_TECHNOLOGY_SUCCESS } from "../actions/keyTechnologiesAction";

  const initialState = {
    keyTechnologiesData: [],
    keyTechnologiesLoading: true,
    keyTechnologiesError: null,
  };
  
  const keyTechnologiesReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_KEY_TECHNOLOGY_REQUEST:
        return { ...state, keyTechnologiesLoading: true , payload: action.payload};
      case FETCH_KEY_TECHNOLOGY_SUCCESS:
        return { ...state, keyTechnologiesLoading: false, keyTechnologiesData: action.payload };
      case FETCH_KEY_TECHNOLOGY_FAILURE:
        return { ...state, keyTechnologiesLoading: false, keyTechnologiesError: action.payload };
      default:
        return state;
    }
  };
  
  export default keyTechnologiesReducer;
  